import React from 'react'
import { Link } from 'react-router-dom'
import Quiz from './Quiz'
import Zoom from 'react-reveal/Zoom';

function Title() {
  return (

    <div className='flex flex-col mt-24 min-h-[400px]'>
      
       <h1 className='flex ml-2 mt-3 justify-center sm:text-8xl text-6xl items-center content-center  sm:text-transparent  sm:bg-clip-text sm:bg-gradient-to-r from-blue-500 to-orange-600 text-[#9b2b78]'>
          Mental Health Quiz
       </h1>
       <p className="pl-2 pr-2 mt-2">
        Take this Quiz and earn coins and redeem them when, you will book any service from website, app or clinic 
       </p>
       <Link to='/quiz' element={Quiz}>
       <button className='mt-8 text-xl text-white bg-purple-500 p-3 rounded-full'>
        Start Quiz
       </button>
      </Link>
      
    </div>
  )
}

export default Title